import { Chip } from "@mui/material";
import type { FC } from "react";
import { getTrendChipProps } from "web_myplann/Portfolio/Helpers/getTrendChipProps";

const TREND_ICON_SIZE = 10;

type Props = {
	percent: number | null | undefined;
};

export const PerformanceBadge: FC<Props> = ({ percent }) => {
	const trend = getTrendChipProps(percent);

	if (trend === null) {
		return null;
	}

	return (
		<Chip
			variant="performance"
			color={trend.color}
			icon={<trend.Icon size={TREND_ICON_SIZE} />}
			label={trend.label}
		/>
	);
};
